import { call, select, put, all } from 'redux-saga/effects';
import { putJSON, deleteJSON } from '../../../shared/util-fetch';

export function* updateList(code, subscribe) {
    const [api, member_uuid] = yield all([
        select(state => state.api.host),
        select(state => state.user.member_uuid),
    ]);
    const url = `${api}/mail/subscription/${member_uuid}/${code}`;

    try {
        yield call(subscribe ? putJSON : deleteJSON, url, {
            reason: 'email',
            location: document.location.href,
        });
        if (!subscribe) {
            yield put({
                type: 'email-unsub:update',
                payload: {
                    error: null,
                    completed: true,
                },
            });
        }
    } catch (e) {
        yield put({
            type: 'email-unsub:update',
            payload: {
                error: `${subscribe ? 'Subscribe' : 'Unsubscribe'} Failed`,
            },
        });
    }
}

export function* root() {
    const slice = yield select(state => state['email-unsub']);
    if (!slice || !slice.code) {
        return;
    }

    if (yield select(state => state.route)) {
        yield put({
            type: 'route:to',
            payload: '',
        });
    }

    yield put({
        type: 'email-unsub:update',
        payload: { submitting: true, error: null },
    });
    try {
        yield call(updateList, slice.code, false);
    } finally {
        yield put({
            type: 'email-unsub:update',
            payload: { submitting: false },
        });
    }
}
